<template>
    <div class="genomics-pos-info">
        <div class="genomics-tabs" v-if="tabType == 'all'">
            <span class="close-modal iconfont icon-guanbishixin" @click="cancel"></span>
            <span :class="tabIndex == 3 ? 'tabs-name on' : 'tabs-name'" @click="tabsCk(3)">
                全部_{{ this.geneName }}
            </span>
        </div>
        <div class="genomics-tabs" v-else-if="tabType == 'part'">
            <span class="close-modal iconfont icon-guanbishixin" @click="cancel"></span>
            <span :class="tabIndex == 2 ? 'tabs-name on' : 'tabs-name'" @click="tabsCk(2)">
                全部_{{ this.queryData.pos }}
            </span>
            <span :class="tabIndex == 3 ? 'tabs-name on' : 'tabs-name'" @click="tabsCk(3)">
                全部_{{ this.geneName }}
            </span>
        </div>
        <div class="genomics-tabs" v-else>
            <span class="close-modal iconfont icon-guanbishixin" @click="cancel"></span>
            <span :class="tabIndex == 1 ? 'tabs-name on' : 'tabs-name'" @click="tabsCk(1)">
                {{ this.tabsName1 }}
            </span>
            <span :class="tabIndex == 2 ? 'tabs-name on' : 'tabs-name'" @click="tabsCk(2)">
                全部_{{ this.queryData.pos }}
            </span>
            <span :class="tabIndex == 3 ? 'tabs-name on' : 'tabs-name'" @click="tabsCk(3)">
                全部_{{ this.geneName }}
            </span>
        </div>

        <div class="genomice-sankey-main">
            <div id="genomics-pos-svg" class="genomics-pos-svg" style="min-height: 300px">
                <div v-if="pdData.pies && pdData.pies.length == 0" class="mb-data-none molecular-none">
                    <div class="none-img"></div>
                    <div class="text">暂无分子分型数据</div>
                </div>
            </div>
        </div>
        <template v-if="tabIndex == 2 || tabIndex == 3">
            <div class="genomice-table-main" v-if="tabType != 'part'">
                <div class="genomice-table-title">突变 <span class="f-export" @click="exportExcel('snp')">下载excel</span>
                </div>
                <a-table :pagination="false" :columns="snpColumns" :dataSource="snpDataLst" :loading="loading"
                    :scroll="{ x: 1560, y: 1560 }" :rowKey="record => record.id" class="hospital-table" size="small">
                </a-table>
            </div>
            <div class="genomice-table-main">
                <div class="genomice-table-title">融合 <span class="f-export"
                        @click="exportExcel('fusion')">下载excel</span>
                </div>
                <a-table :pagination="false" :columns="fusionColumns" :dataSource="fusionDataLst" :loading="loading"
                    :scroll="{ x: 1530, y: 560 }" :rowKey="record => record.id" class="hospital-table" size="small">
                </a-table>
            </div>
        </template>
        <template v-else>
            <div class="genomice-table-main" v-if="!queryData.key">
                <div class="genomice-table-title">突变 <span class="f-export" @click="exportExcel('snp')">下载excel</span>
                </div>
                <a-table :pagination="false" :columns="snpColumns" :dataSource="snpDataLst" :loading="loading"
                    :scroll="{ x: 1760, y: 760 }" :rowKey="(record, index) => { return index }" class="hospital-table"
                    size="small">
                </a-table>
            </div>
            <div class="genomice-table-main" v-if="queryData.key">
                <div class="genomice-table-title">融合 <span class="f-export"
                        @click="exportExcel('fusion')">下载excel</span>
                </div>
                <a-table :pagination="false" :columns="fusionColumns" :dataSource="fusionDataLst" :loading="loading"
                    :scroll="{ x: 2130, y: 760 }" :rowKey="(record, index) => { return index }" class="hospital-table"
                    size="small">
                </a-table>
            </div>
        </template>
    </div>
</template>

<script>
import NProgress from 'nprogress';

const fusionColumns = [
    {
        title: "序号",
        customRender: (text, record, index) => `${index + 1}`,
        width: "40px",
    },
    {
        title: "Sample",
        dataIndex: "hosBarCode",
        scopedSlots: { customRender: "hosBarCode" },
        width: "100px",
    },
    {
        title: "Clinical_Signifrcance",
        dataIndex: "clinicalSignificance",
        customRender: (text, record, index) => {
            if (!record.clinicalSignificance) {
                return "-";
            } else {
                return record.clinicalSignificance;
            }
        },
        width: '80px',
    },
    {
        title: "geneA",
        dataIndex: "geneA",
        customRender: (text, record, index) => {
            if (!record.geneA) {
                return "-";
            } else {
                return record.geneA;
            }
        },
        width: '55px',
    },
    {
        title: "ChrA",
        dataIndex: "chrA",
        customRender: (text, record, index) => {
            if (!record.chrA) {
                return "-";
            } else {
                return record.chrA;
            }
        },
        width: '50px',
    },
    {
        title: "posA",
        dataIndex: "posA",
        customRender: (text, record, index) => {
            if (!record.posA) {
                return "-";
            } else {
                return record.posA;
            }
        },
        width: '85px',
    },
    {
        title: "ortA",
        dataIndex: "ortA",
        customRender: (text, record, index) => {
            if (!record.ortA) {
                return "-";
            } else {
                return record.ortA;
            }
        },
        width: '50px',
    },
    {
        title: "featureA",
        dataIndex: "featureA",
        customRender: (text, record, index) => {
            if (!record.featureA) {
                return "-";
            } else {
                return record.featureA;
            }
        },
        width: '80px',
    },
    {
        title: "geneB",
        dataIndex: "geneB",
        customRender: (text, record, index) => {
            if (!record.geneB) {
                return "-";
            } else {
                return record.geneB;
            }
        },
        width: '60px',
    },
    {
        title: "ChrB",
        dataIndex: "chrB",
        customRender: (text, record, index) => {
            if (!record.chrB) {
                return "-";
            } else {
                return record.chrB;
            }
        },
        width: '50px',
    },
    {
        title: "posB",
        dataIndex: "posB",
        customRender: (text, record, index) => {
            if (!record.posB) {
                return "-";
            } else {
                return record.posB;
            }
        },
        width: '85px',
    },
    {
        title: "ortB",
        dataIndex: "ortB",
        customRender: (text, record, index) => {
            if (!record.ortB) {
                return "-";
            } else {
                return record.ortB;
            }
        },
        width: '50px',
    },
    {
        title: "featureB",
        dataIndex: "featureB",
        customRender: (text, record, index) => {
            if (!record.featureB) {
                return "-";
            } else {
                return record.featureB;
            }
        },
        width: '65px',
    },
    {
        title: "type",
        dataIndex: "type",
        customRender: (text, record, index) => {
            if (!record.type) {
                return "-";
            } else {
                return record.type;
            }
        },
        width: '50px',
    },
    {
        title: "score",
        dataIndex: "score",
        customRender: (text, record, index) => {
            if (!record.score) {
                return "-";
            } else {
                return record.score;
            }
        },
        width: '55px',
    },
    {
        title: "frame",
        dataIndex: "frame",
        customRender: (text, record, index) => {
            if (!record.frame) {
                return "-";
            } else {
                return record.frame;
            }
        },
        width: '155px',
    },
    {
        title: "sv_refseqA",
        dataIndex: "sv_refseqA",
        customRender: (text, record, index) => {
            if (!record.sv_refseqA) {
                return "-";
            } else {
                return record.sv_refseqA;
            }
        },
        width: '355px',
    },
    {
        title: "sv_refseqB",
        dataIndex: "sv_refseqB",
        customRender: (text, record, index) => {
            if (!record.sv_refseqB) {
                return "-";
            } else {
                return record.sv_refseqB;
            }
        },
        width: '355px',
    },
    {
        title: "Fusion_description",
        dataIndex: "fusionDescription",
        customRender: (text, record, index) => {
            if (!record.fusionDescription) {
                return "-";
            } else {
                return record.fusionDescription;
            }
        },
        width: "190px",
    },
    {
        title: "Gene_1_id",
        dataIndex: "gene1Id",
        customRender: (text, record, index) => {
            if (!record.gene1Id) {
                return "-";
            } else {
                return record.gene1Id;
            }
        },
        width: '75px',
    },
    {
        title: "Gene_2_id",
        dataIndex: "gene2Id",
        customRender: (text, record, index) => {
            if (!record.gene2Id) {
                return "-";
            } else {
                return record.gene2Id;
            }
        },
        width: '75px',
    },
    {
        title: "Predicted_effect",
        dataIndex: "predictedEffect",
        customRender: (text, record, index) => {
            if (!record.predictedEffect) {
                return "-";
            } else {
                return record.predictedEffect;
            }
        },
        width: "90px",
    },
];
const snpColumns = [
    {
        title: "序号",
        customRender: (text, record, index) => `${index + 1}`,
        width: "40px",
    },
    {
        title: "Sample",
        dataIndex: "hosBarCode",
        scopedSlots: { customRender: "hosBarCode" },
        width: '100px',
    },
    {
        title: "Chinical_Signifrcance",
        dataIndex: "clinicalSignificance",
        customRender: (text, record, index) => {
            if (!record.clinicalSignificance) {
                return "-";
            } else {
                return record.clinicalSignificance;
            }
        },
        width: '80px',
    },
    {
        title: "Chr",
        dataIndex: "chr",
        customRender: (text, record, index) => {
            if (!record.chr) {
                return "-";
            } else {
                return record.chr;
            }
        },
        width: '50px',
    },
    {
        title: "Pos",
        dataIndex: "pos",
        customRender: (text, record, index) => {
            if (!record.pos) {
                return "-";
            } else {
                return record.pos;
            }
        },
        width: '85px',
    },
    {
        title: "Ref",
        dataIndex: "ref",
        customRender: (text, record, index) => {
            if (!record.ref) {
                return "-";
            } else {
                return record.ref;
            }
        },
        width: '150px',
    },
    {
        title: "Alt",
        dataIndex: "alt",
        customRender: (text, record, index) => {
            if (!record.alt) {
                return "-";
            } else {
                return record.alt;
            }
        },
        width: '150px',
    },
    {
        title: "Ref_Count",
        dataIndex: "refCount",
        customRender: (text, record, index) => {
            if (!record.refCount) {
                return "-";
            } else {
                return record.refCount;
            }
        },
        width: '75px',
    },
    {
        title: "Alt_Count",
        dataIndex: "altCount",
        customRender: (text, record, index) => {
            if (!record.altCount) {
                return "-";
            } else {
                return record.altCount;
            }
        },
        width: '75px',
    },
    {
        title: "Vaf",
        dataIndex: "Vaf",
        customRender: (text, record, index) => {
            if (!record.vaf) {
                return "-";
            } else {
                return record.vaf;
            }
        },
        width: '65px',
    },
    {
        title: "Consequence",
        dataIndex: "consequence",
        customRender: (text, record, index) => {
            if (!record.displayConsequence) {
                return "-";
            } else {
                return record.displayConsequence;
            }
        },
    },
    {
        title: "Gene_Symbol",
        dataIndex: "geneSymbol",
        customRender: (text, record, index) => {
            if (!record.geneSymbol) {
                return "-";
            } else {
                return record.geneSymbol;
            }
        },
        width: '65px',
    },
    {
        title: "Gene_ID",
        dataIndex: "geneId",
        customRender: (text, record, index) => {
            if (!record.geneId) {
                return "-";
            } else {
                return record.geneId;
            }
        },
        width: '80px',
    },
    {
        title: "Transcript_ID",
        dataIndex: "transcriptId",
        customRender: (text, record, index) => {
            if (!record.transcriptId) {
                return "-";
            } else {
                return record.transcriptId;
            }
        },
    },
    {
        title: "NTchange",
        dataIndex: "ntchange",
        customRender: (text, record, index) => {
            if (!record.ntchange) {
                return "-";
            } else {
                return record.ntchange;
            }
        },
    },
    {
        title: "Amino_acids",
        dataIndex: "aminoAcids",
        customRender: (text, record, index) => {
            if (!record.aminoAcids) {
                return "-";
            } else {
                return record.aminoAcids;
            }
        },
    },
    {
        title: "AAchange",
        dataIndex: "aachange",
        customRender: (text, record, index) => {
            if (!record.aachange) {
                return "-";
            } else {
                return record.aachange;
            }
        },
    },
];
export default {
    props: {
        queryData: {
            type: Object,
            default: () => { },
        },
        geneName: {
            type: String,
            default: () => { },
        },
        partName: {
            type: String,
            default: () => { },
        }
    },
    data() {
        return {
            tabIndex: 1,
            tabType: 'no',
            tabsName1: '',
            snpColumns,
            fusionColumns,
            snpDataLst: [],
            fusionDataLst: [],
            loading: false,
            snpOpt: {},
            fusionOpt: {},
            allSanKeyOpt: {},
            sankeyDataItemStyle: {
                Database: {
                    color: "#D8D8D8",
                    borderColor: "#D8D8D8",
                },
                NA: {
                    color: "#845656",
                    borderColor: "#845656",
                },
                HM: {
                    color: "#5A9040",
                    borderColor: "#5A9040",
                },
                ST: {
                    color: "#405D90",
                    borderColor: "#405D90",
                },
                BT: {
                    color: "#904080",
                    borderColor: "#904080",
                },
                Other: {
                    color: "#9B9B9B",
                    borderColor: "#9B9B9B",
                },
            },
            sankeyLayerStyle: [
                "#3062CF",
                "#DE3700",
                "#FF9000",
                "#029802",
                "#9B009B",
                "#0398C7",
                "#DF4076",
                "#124E78",
                "#FFC300",
            ],
            nodeGap: 10,
            pdData: {},
        }
    },
    mounted() {
        NProgress.start();
        if (this.queryData.tabIndex == 3) {
            this.tabIndex = this.queryData.tabIndex;
            this.tabType = this.queryData.tabType;
            this.tabsIndexThree();
        } else {
            this.getData();
        }
    },
    methods: {
        tabsCk(index) {
            this.tabIndex = index;
            NProgress.start();
            if (index == 2) {
                this.allSanKeyOpt = Object.assign({}, {
                    name: this.geneName,
                    partName: this.partName,
                    pos: this.queryData.pos,
                }, this.queryData.checkeds);
                this.fusionOpt = Object.assign({}, {
                    name: this.geneName,
                    partName: this.partName,
                    pos: this.queryData.pos,
                }, this.queryData.checkeds);
                this.snpOpt = Object.assign({}, {
                    name: this.geneName,
                    partName: this.partName,
                    pos: this.queryData.pos,
                }, this.queryData.checkeds);
                this.getAllSankey();
                this.getAllList();
            } else if (index == 3) {
                this.tabsIndexThree();
            } else {
                this.getData();
            }
        },
        tabsIndexThree() {
            this.allSanKeyOpt = Object.assign({}, {
                name: this.geneName,
                partName: this.partName,
            }, this.queryData.checkeds);
            this.fusionOpt = Object.assign({}, {
                name: this.geneName,
                partName: this.partName,
            }, this.queryData.checkeds);
            this.snpOpt = Object.assign({}, {
                name: this.geneName,
                partName: this.partName,
            }, this.queryData.checkeds);
            this.getAllSankey();
            this.getAllList();
        },
        cancel() {
            this.$emit('cancel');
        },
        getData() {
            let type = 'snp';
            if (this.queryData.key) {
                type = 'fusion';
                let otherGene = this.queryData.key == "a" ? this.queryData.b.gene : this.queryData.a.gene;
                let otherGeneAry = this.queryData.key == "a" ? this.queryData.b.geneAry : this.queryData.a.geneAry;
                if (otherGeneAry instanceof Array) {
                    otherGene = '';
                    this.tabIndex = 2;
                    this.tabType = 'part';
                }
                this.fusionOpt = Object.assign({}, {
                    name: this.geneName,
                    partName: this.partName,
                    isGeneA: this.queryData.key == "a" ? true : false,
                    pos: this.queryData.pos,
                    otherGene: otherGene,
                }, this.queryData.checkeds);
                this.tabsName1 = otherGene;
            } else {
                type = 'snp';
                let aminoAcids = this.queryData.aminoAcids;
                if (this.queryData.aminoAcids instanceof Array) {
                    this.tabIndex = 2;
                    this.tabType = 'part';
                    aminoAcids = '';
                }
                this.snpOpt = Object.assign({}, {
                    name: this.geneName,
                    partName: this.partName,
                    pos: this.queryData.pos,
                    aminoAcids: aminoAcids
                }, this.queryData.checkeds);
                this.tabsName1 = aminoAcids;
            }
            switch (type) {
                case "snp":
                    this.getSnpList();
                    this.getSnpSankey();
                    break;
                case "fusion":
                    this.getFusionList();
                    this.getFusionSankey();
                    break;
            }
            NProgress.done();
        },
        getAllList() {
            this.getSnpList();
            this.getFusionList();
            NProgress.done();
        },
        getSnpList() {
            /**
             * name=基因名称&partName=基因片段名称（可为空）&pos=位置&aminoAcids=氨基酸名称
             */
            let $this = this;
            $this.loading = true;
            let opt = Object.assign({}, $this.snpOpt)
            $this.$get("/gene/bbdata_snp_list", opt).then(
                (res) => {
                    $this.snpDataLst = res.data.data;
                    $this.loading = false;

                }
            );
        },
        getSnpSankey() {
            /**
             * name=基因名称&partName=基因片段名称（可为空）&pos=位置&aminoAcids=氨基酸名称
             */
            let $this = this;
            let opt = Object.assign({}, $this.snpOpt)
            $this.$get("/gene/bbdata_snp_sankey", opt).then(
                (res) => {
                    $this.formatSankey(res.data.data, res.data.data.total);
                }
            );
        },
        getFusionList() {
            /**
             * name=基因名称&partName=基因片段名称（可为空）&pos=位置&isGeneA=true|false（是否是基因A,不设置查全部）&otherGene=另一个基因名称
             */
            let $this = this;
            $this.loading = true;
            let opt = Object.assign({}, $this.fusionOpt)
            $this.$get("/gene/bbdata_fusion_list", opt).then(
                (res) => {
                    $this.fusionDataLst = res.data.data;
                    $this.loading = false;

                }
            );
        },
        getFusionSankey() {
            /**
             * name=基因名称&partName=基因片段名称（可为空）&pos=位置&isGeneA=true|false（是否是基因A,不设值查全部）&otherGene=另一个基因名称
             */
            let $this = this;
            let opt = Object.assign({}, $this.fusionOpt)
            $this.$get("/gene/bbdata_fusion_sankey", opt).then(
                (res) => {
                    $this.formatSankey(res.data.data, res.data.data.total);
                }
            );
        },
        getAllSankey() {
            /**
             * name=基因名称&partName=基因片段名称（可为空）&pos=位置
             */
            let $this = this;
            $this.$get("/gene/bbdata_all_sankey", $this.allSanKeyOpt).then(
                (res) => {
                    $this.formatSankey(res.data.data, res.data.data.total);
                }
            );
        },
        exportExcel(type) {
            let url = "";
            let opt = {};
            let dFilename = "";
            switch (type) {
                case "snp":
                    url = "gene/export_bbdata_snp_list";
                    opt = this.snpOpt;
                    dFilename = "突变_位点";
                    break;
                case "fusion":
                    url = "gene/export_bbdata_fusion_list";
                    opt = this.fusionOpt;
                    dFilename = "融合_位点";
                    break;
            }
            this.$export(url, opt, dFilename);
        },
        formatSankey(data, total) {
            this.pdData = data;
            let $this = this;
            if (this.pdData.pies && this.pdData.pies.length != 0) {
                this.pdData.pies.forEach((item, index) => {
                    let itemIndex = index + 1;
                    item["itemStyle"] = $this.sankeyDataItemStyle[item.name];
                    if (index == 1) {
                        if (!item.children) {
                            item.children = [
                                {
                                    name: "toNull" + index,
                                    showName: "toNull" + index,
                                    itemStyle: {
                                        color: "#fff",
                                        opacity: 0,
                                    },
                                    lineStyle: {
                                        color: "#fff",
                                    },
                                    mtId: 999999 + index,
                                    total: item.total,
                                    layer: 2,
                                    children: null,
                                },
                            ];
                        } else {
                            item.children.forEach((ary, index) => {
                                ary["itemStyle"] = {
                                    color: $this.sankeyLayerStyle[index],
                                    borderColor: $this.sankeyLayerStyle[index],
                                };
                            });
                        }
                    } else {
                        if (!item.children) {
                            item.children = [
                                {
                                    name: "toNull" + index,
                                    showName: "toNull" + index,
                                    itemStyle: {
                                        color: "#fff",
                                        opacity: 0,
                                    },
                                    lineStyle: {
                                        color: "#fff",
                                    },
                                    mtId: 999999 + index,
                                    total: item.total,
                                    layer: 2,
                                    children: null,
                                },
                            ];
                        } else {
                            item.children.forEach((ary, index) => {
                                ary["itemStyle"] = {
                                    color: $this.sankeyLayerStyle[index],
                                    borderColor: $this.sankeyLayerStyle[index],
                                };
                            });
                        }
                    }
                });
                this.pdData.pies.sort(function (a, b) {
                    return a.name.localeCompare(b.name);
                });
                let dJson = {
                    name: "Database",
                    showName: "Database",
                    mtId: 1000000,
                    total: total,
                    layer: 0,
                    itemStyle: $this.sankeyDataItemStyle["Database"],
                    children: this.pdData.pies,
                };
                $this.initSankey(
                    $this.traverseTree(dJson),
                    $this.traverseTreeLinks(dJson)
                );
            } else {
                this.pdData.pies = [];
                $this.initSankey([], []);
            }
        },
        initSankey(data, links) {
            let that = this;
            let chartDom = document.getElementById("genomics-pos-svg");
            let myChart = this.$echarts.init(chartDom, null, { renderer: "svg" });
            let option = {
                tooltip: {
                    trigger: "item",
                    formatter: function (a) {
                        let data = eval(a["data"]);
                        let result = "";
                        if (data.target && data.target.indexOf("toNull") != -1) {
                            result = "";
                        } else if (data.target) {
                            result = that.splitShowName(a.name);
                        } else if (data.name == "Database") {
                            result =
                                that.splitShowName(a.name) + "（" + data.total + " samples）";
                        } else {
                            result =
                                that.splitShowName(a.name) + "<br/>(" + data.fullName + ")";
                        }
                        return result;
                    },
                },
                series: {
                    type: "sankey",
                    left: 2.0,
                    top: 0,
                    right: 20.0,
                    bottom: 10,
                    lineStyle: {
                        color: "target",
                        curveness: 0.5,
                    },
                    itemStyle: {
                        normal: {
                            borderWidth: 1,
                        },
                    },
                    draggable: false,
                    nodeWidth: 20,
                    nodeGap: that.nodeGap,
                    emphasis: {
                        focus: "adjacency",
                    },
                    nodeAlign: "left",
                    layoutIterations: 32,
                    selectedMode: true,
                    select: {
                        label: {
                            color: "#000",
                            show: true,
                        },
                        itemStyle: {
                            shadowColor: "#428EF7",
                            shadowBlur: 10,
                            borderColor: "#428EF7",
                            borderWidth: 2,
                            borderType: "solid",
                        },
                    },
                    label: {
                        normal: {
                            position: "left",
                            formatter: function (a) {
                                let data = eval(a["data"]);
                                let result = "";
                                if (data.name == "Database") {
                                    result = "Database from " + data.total + " samples";
                                } else {
                                    result = that.splitShowName(data.name);
                                }
                                return result;
                            },
                            color: "#162232",
                            padding: [0, 10, 0, 10],
                        },
                    },
                    levels: [
                        {
                            depth: 0,
                            label: {
                                show: true,
                                position: "inside",
                                rotate: 90,
                                fontWeight: "600",
                            },
                        },
                        {
                            depth: 1,
                            label: {
                                position: "insideLeft",
                                fontWeight: "600",
                                align: "center",
                                offset: [-100, 0],
                                formatter: function (a) {
                                    let data = eval(a["data"]);
                                    if (data.percentage > 10) {
                                        return (
                                            that.splitShowName(data.name) +
                                            "\n" +
                                            data.fullName +
                                            "\n" +
                                            data.total +
                                            "/" +
                                            that.pdData.total +
                                            "\n" +
                                            data.percentage +
                                            "%"
                                        );
                                    } else {
                                        return (
                                            that.splitShowName(data.name) +
                                            " " +
                                            data.percentage +
                                            "%"
                                        );
                                    }
                                },
                            },
                        },
                    ],
                    data: data,
                    links: links,
                },
            };

            option && myChart.setOption(option, true);
            //建议加上以下这一行代码，不加的效果图如下（当浏览器窗口缩小的时候）。超过了div的界限（红色边框）
            window.addEventListener("resize", function () {
                myChart.resize();
            });

        },
        splitShowName(str) {
            let result = "";
            if (str) {
                if (str.indexOf(">") != -1) {
                    let strAry = str.split(">");
                    result =
                        strAry[0].split("#")[0] + " &nbsp;> " + strAry[1].split("#")[0];
                } else {
                    result = str.split("#")[0];
                }
            } else {
                result = str;
            }
            return result;
        },
        traverseTree(node, parentTotal, parentSource, itemStyle) {
            let that = this;
            let total = node.total;
            let child = node.children,
                arr = [],
                label = { show: true, lineHeight: 16 };
            let json = {};
            json.name = node.showName;
            json.fullName = node.fullName;
            json.total = node.total;
            json.parentTotal = parentTotal;
            json.percentage = node.percentage;
            json.mtId = node.mtId;
            json.layer = node.layer;
            if (json.name.indexOf("toNull") != -1) {
                json.label = { show: false };
            } else {
                json.label = label;
            }
            if (node.depth != undefined) {
                json.depth = node.depth;
            }
            if (itemStyle) {
                json.itemStyle = itemStyle;
            } else {
                json.itemStyle = node.itemStyle;
            }
            if (parentSource) {
                json.parentSource = parentSource + "_" + node.name;
            } else {
                json.parentSource = node.name;
            }
            arr.push(json);
            if (child) {
                child.forEach(function (node) {
                    if (node.itemStyle) {
                        arr = arr.concat(
                            that.traverseTree(node, total, json.parentSource, node.itemStyle)
                        );
                    } else {
                        arr = arr.concat(
                            that.traverseTree(node, total, json.parentSource, json.itemStyle)
                        );
                    }
                });
            }
            return arr;
        },
        traverseTreeLinks(node) {
            let that = this;
            let child = node.children,
                arr = [];
            if (child) {
                child.forEach(function (childs) {
                    let json = {};
                    json.source = node.showName;
                    json.fullName = node.fullName;
                    json.target = childs.showName;
                    json.value = childs.total;
                    if (json.name != "Database") {
                        arr.push(json);
                    }
                    arr = arr.concat(that.traverseTreeLinks(childs));
                });
            }
            return arr;
        },
    }
}
</script>

<style lang="scss" scoped>
.genomics-pos-info {
    position: relative;
    padding: 40px 15px 40px 15px;

    .close-modal {
        position: relative;
        top: 3px;
        cursor: pointer;
        padding: 3px 0 3px 5px;
        display: inline-block;
        color: #E51313;
    }

    .genomics-tabs {
        position: absolute;
        top: -15px;
        left: 0;
        right: 0;
        height: 42px;
        border-bottom: 1px solid #F0F2F5;
        padding-left: 3px;

        .tabs-name {
            font-size: 14px;
            display: inline-block;
            padding: 8px 10px;
            color: #9B9B9B;
            cursor: pointer;
            position: relative;
            top: 3px;

            &.on {
                color: #428EF7;
                border-bottom: 2px solid #428EF7;
                background: #FFFFFF;
                // box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.5);
            }
        }
    }

    .genomics-pos-svg {
        width: 85%;
        min-height: 300px;
        position: relative;
        margin: 0 auto;
    }

    .genomice-sankey-main {
        min-height: 150px;
    }

    /deep/ .ant-table-small .ant-table-thead th {
        line-height: 12px;
    }

    /deep/ .ant-table-small .ant-table-body td {
        line-height: 18px;
    }

    .genomice-table-title {
        font-size: 14px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: bold;
        color: #1F1F1F;
        line-height: 24px;
        padding: 10px 15px;

        .f-export {
            float: right;
            display: inline-block;
            background: #4C83FF;
            color: #FFFFFF;
            font-size: 12px;
            line-height: 22px;
            padding: 2px 10px;
            cursor: pointer;
        }
    }

    .mb-data-none {
        position: absolute;
        top: 50%;
        left: 50%;
        z-index: 9;
        width: 100px;
        margin-top: -32px;
        margin-left: -50px;
        font-size: 12px;
        color: #cacaca;
        text-align: center;
        line-height: 32px;

        .none-img {
            width: 40px;
            height: 40px;
            margin: 0 auto;
            background: no-repeat center;
        }

        &.molecular-none {
            .none-img {
                background-image: url("../../assets/image/homeImg/marshalling.png");
            }
        }

        &.hospital-none {
            .none-img {
                background-image: url("../../assets/image/homeImg/hospital-none.png");
            }
        }
    }
}
</style>